import { render, staticRenderFns } from "./SubEditView.vue?vue&type=template&id=bcab6286&"
import script from "./SubEditView.vue?vue&type=script&lang=js&"
export * from "./SubEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports